<ab-loader [showLoader]="isLoading"></ab-loader>

<ng-container>
  <ng-container *ngIf="userBlockedError">
    <div class="container">
      <div class="alert alert-danger">User is permanently blocked!</div>
    </div>
  </ng-container>

  <ng-container *ngIf="invalidCredentialsError">
    <div class="container">
      <div class="alert alert-danger">
        Invalid credentials. Your access will be blocked after multiple incorrect attempts.
      </div>
    </div>
  </ng-container>
  <div class="container">
    <div class="panel">
      <ng-container *ngIf="authorizationMethod === 'qr'">
        <h1 class="landing-title">Select approval method</h1>
        <div class="landing-container">
          <div class="method-container">
            <h2 class="method-title">Login with {{ items?.bankApplication.fields.text.value }}</h2>
            <div class="helpsteps-container">
              <div class="list-numbered">
                <ul class="list-numbered fixed-view">
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>1</span>
                      </div>
                    </div>
                    <div>
                      <span>Open the {{ items?.bankApplication.fields.text.value }}</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>2</span>
                      </div>
                    </div>
                    <div>
                      <span>Tap on the QR-code icon in the left corner</span>
                      <div
                        [ngClass]="{
                          'app-image-orco': items?.bankName.fields.text.value === 'Orco Bank',
                          'app-image-aruba': items?.bankName.fields.text.value === 'Aruba Bank'
                        }"
                        class="app-image"></div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>3</span>
                      </div>
                    </div>
                    <div>
                      <span>Scan the QR-code and approve payment</span>
                      <div class="qr-container" [ngClass]="{ 'retry-qr': retryQR }">
                        <img [src]="qrCodeImage" class="qr-code-image" />
                        <button class="btn-retry-qr" (click)="getQrCodeImage()"></button>
                        <p>Click to generate a new QR code</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="method-container">
            <h2 class="method-title">Login with token</h2>
            <div class="helpsteps-container">
              <div class="list-numbered">
                <ul class="list-numbered fixed-view">
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>1</span>
                      </div>
                    </div>
                    <div>
                      <div>Click on below button to login to {{ items?.bankName.fields.text.value }} Online</div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>2</span>
                      </div>
                    </div>
                    <div>
                      <div>Follow the steps to approve payment</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <button class="btn btn-outline-primary btn-step" (click)="authorizationMethod = 'token'">
              <span>Continue to {{ items?.bankName.fields.text.value }} Online</span>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="authorizationMethod === 'token'">
        <h1 class="heading-primary login-title">Log in with {{ items?.bankToken.fields.text.value }}</h1>
        <div class="login-container">
          <div class="form-container">
            <form [formGroup]="loginForm" (submit)="login()">
              <!-- username field -->
              <div class="label-login">
                <label class="login" for="safeName">
                  Enter your {{ items?.bankName.fields.text.value }} user name
                </label>
                <input
                  class="form-control"
                  placeholder="Username"
                  formControlName="username"
                  #usernameInput
                  [maxlength]="250" />
                <span class="field-validation-error" *ngIf="username.errors?.required">Username required</span>
              </div>

              <!-- logincode field -->
              <div class="label-login">
                <label class="login" for="logincode">Enter the generated login code</label>
                <input
                  class="form-control"
                  placeholder="1234"
                  formControlName="logincode"
                  #passwordInput
                  [maxlength]="200" />
                <span class="field-validation-error" *ngIf="logincode.errors?.required">Login code required</span>
              </div>

              <div class="form-group label-login">
                <ng-container>
                  <button
                    class="btn btn-primary btn-step"
                    [disabled]="loginForm.invalid || isLoading"
                    abButtonLoader
                    [ngClass]="{ 'btn-loader': isLoading }">
                    <span>Log in</span>
                  </button>
                </ng-container>
              </div>
            </form>

            <button class="btn btn-outline-primary" (click)="authorizationMethod = 'qr'">
              Continue with your mobile app
            </button>
          </div>
          <div class="helpsteps-container">
            <ul class="tabbable-nav">
              <li (click)="selectActiveTab('token')" [ngClass]="{ active: helpMethod === 'token' }">
                <span>{{ items?.bankToken.fields.text.value }}</span>
              </li>
              <li (click)="selectActiveTab('app')" [ngClass]="{ active: helpMethod === 'app' }">
                <span>{{ items?.bankApplication.fields.text.value }}</span>
              </li>
            </ul>
            <p class="fs-16">How to receive the code with the token:</p>
            <ng-container *ngIf="helpMethod === 'token'">
              <div class="list-numbered">
                <ul class="list-numbered fixed-view order-steps-list">
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>1</span>
                      </div>
                    </div>
                    <div>
                      <span
                        >Press <span class="press"><em class="icon-caret-left"></em></span> to turn on the
                        {{ items?.bankToken.fields.text.value }} Token</span
                      >
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>2</span>
                      </div>
                    </div>
                    <div>
                      <span>Enter your 4-digit PIN Code</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>3</span>
                      </div>
                    </div>
                    <div>
                      <span>Press number “1”</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>4</span>
                      </div>
                    </div>
                    <div>
                      <span
                        >Enter the Login Code generated by the {{ items?.bankToken.fields.text.value }} in the
                        designated text field</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </ng-container>
            <ng-container *ngIf="helpMethod === 'app'">
              <div class="list-numbered">
                <ul class="list-numbered fixed-view order-steps-list">
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>1</span>
                      </div>
                    </div>
                    <div>
                      <span>Open your {{ items?.bankApplication.fields.text.value }} &reg; on your mobile phone</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>2</span>
                      </div>
                    </div>
                    <div>
                      <span>Click on the 'Token' icon in the mobile app menu</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>3</span>
                      </div>
                    </div>
                    <div>
                      <span>Select 'Login Code' from the screen</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>4</span>
                      </div>
                    </div>
                    <div>
                      <span
                        >Enter your 5-digit PIN Code for the {{ items?.bankApplication.fields.text.value }}&reg; to
                        generate the Login Code</span
                      >
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="circle blue">
                        <span>5</span>
                      </div>
                    </div>
                    <div>
                      <span
                        >Enter the generated Login Code generated by the
                        {{ items?.bankApplication.fields.text.value }}&reg; in the field above</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="panel-footer">
      <p class="fs-16">
        Need help?
        <a [href]="items.contact.fields.text.value" target="_blank">Contact us<span class="icon-opentab"></span> </a>
      </p>
    </div>
  </div>
</ng-container>
